// src/landing/components/AboutSection.js
import React, { useContext } from 'react';
import '../styles/AboutSection.css';
import { LanguageContext } from '../../common/contexts/LanguageContext';

export default function AboutSection() {
  const { t } = useContext(LanguageContext);
  const aboutImg = '/img/about_main.jpg';

  return (
    <section id="about" className="about-section">
      <h2 className="title">{t('aboutSection.title')}</h2>
      <p className="subtitle">{t('aboutSection.subtitle')}</p>

      <div className="about-grid">
        {/* 왼쪽 이미지 */}
        <div className="img-wrap">
          <img
            src={aboutImg}
            alt={t('aboutSection.imgAlt') || 'About image'}
          />
        </div>

        {/* 오른쪽 텍스트 */}
        <div className="about-text">
          <h3>{t('aboutSection.companyName')}</h3>
          <p>{t('aboutSection.description1')}</p>
          <p>{t('aboutSection.description2')}</p>
        </div>
      </div>
    </section>
  );
}
